import { render, staticRenderFns } from "./shop-recharge-detail.vue?vue&type=template&id=ce838528&"
import script from "./shop-recharge-detail.vue?vue&type=script&lang=js&"
export * from "./shop-recharge-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports